import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { PaymentDto, PaymentUpdateRequestDto } from 'interfaces/orders/payment';

interface PaymentService {
  list(orderId: string): Promise<PaymentDto[]>;
  update(orderId: string, paymentId: string, data: PaymentUpdateRequestDto): Promise<PaymentDto>;
}

const endpoints = {
  list: (orderId: string) => `/orders/${orderId}/payments`,
  update: (orderId: string, paymentId: string) => `/orders/${orderId}/payments/${paymentId}`,
};

const getErrorMessage = (response: ApiResponseDto<unknown>): string => response.errors!.map(error => error.message).join(', ');
const isNotFoundResponse = (response?: ApiResponseDto<unknown>): boolean =>
  response?.errors?.some(error => error.code === 'NOT_FOUND') ?? false;
const getHttpStatus = (error: unknown): number | undefined => (error as { response?: { status?: number } }).response?.status;

export const paymentsService: PaymentService = {
  list: async (orderId: string): Promise<PaymentDto[]> => {
    try {
      const response: AxiosResponse<ApiResponseDto<PaymentDto[]>> = await apiClient.get(endpoints.list(orderId));

      if (isNotFoundResponse(response.data)) {
        return [];
      }

      if (response.data.errors) {
        throw new Error(getErrorMessage(response.data));
      }

      return response.data.data!;
    } catch (error) {
      if (getHttpStatus(error) === 404) {
        return [];
      }

      throw error;
    }
  },

  update: async (orderId: string, paymentId: string, data: PaymentUpdateRequestDto): Promise<PaymentDto> => {
    const response: AxiosResponse<ApiResponseDto<PaymentDto>> = await apiClient.patch(endpoints.update(orderId, paymentId), data);

    if (response.data.errors) {
      throw new Error(getErrorMessage(response.data));
    }

    return response.data.data!;
  },
};
